import { Row, Col } from "antd";
import React from "react";
import ReusableTable from "../../../components/TableComponent";
import HeadingSubHeading from "../../../components/ViewHeading/HeadingSubHeading";
import { MasterConfigs } from "../../../interfaces/entity";

const CompOffs = () => {

    const config: MasterConfigs = {
        api: () => '/leave-approval',
        title: 'Approval Leaves',
        modalTitle: () => 'Approval Leave',
        getColumns: () => [
            {
                title: 'Employee Name',
                dataIndex: 'employeeName',
                key: 'employeeName',
            },
            {
                title: 'Department',
                dataIndex: 'department',
                key: 'department',
            },
            {
                title: 'Leave Type',
                dataIndex: 'leaveType',
                key: 'leaveType',
            }, {
                title: 'From Date',
                dataIndex: 'fromDate',
                key: 'fromDate',
            }, {
                title: 'To Date',
                dataIndex: 'toDate',
                key: 'toDate',
            }, {
                title: 'Status',
                dataIndex: 'status',
                key: 'status',
            },
            {
                title: 'Total Leave Days',
                dataIndex: 'totalLeaveDays',
                key: 'totalLeaveDays',
            }, {
                title: 'Leave Note',
                dataIndex: 'leaveNote',
                key: 'leaveNote',
            }, {
                title: 'Updated by',
                dataIndex: 'updatedBy',
                key: 'updatedBy',
            },
            {
                title: 'Action',
                dataIndex: 'action',
                key: 'action',
            }
        ]
    }

    return <Row gutter={[16, 16]}>
        <Col span={24}>
            <HeadingSubHeading title="Approval Leaves" titleProps={{ level: 5 }} />
        </Col>
        <Col span={24}>
            <ReusableTable config={config} />
        </Col>
    </Row>
};

export default CompOffs;